/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Return_DescInputs */

const vi_confirm_return_desc = /** @type {(inputs: Confirm_Return_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn kệ nhập cho hàng tốt và hàng lỗi (tick Hàng lỗi để nhập số lượng lỗi). Kệ khác kệ của lô sẽ tạo lô mới cùng mã; chọn đúng kệ cũ thì cộng vào lô cũ, trừ khi tick Tạo lô mới. Vật tư bao bì: chọn lô và số lượng nhập lại, bỏ tick hoặc để 0 nếu đã hỏng.`)
};

/**

* @param {Confirm_Return_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const confirm_return_desc = /** @type {((inputs?: Confirm_Return_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Return_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_confirm_return_desc(inputs)
});